import React from "react";

const TableProdWidget = ({ item, handleView, discount }) => {
  const renderContent = () => {
    if (!item) return "null";
    switch (item.prodType) {
      case 1:
        return item.prod ? (
          <div
            className="grid gap-1 font-medium text-gray-500"
            onClick={() => handleView(item)}
          >
            <span className="text-[15px] link">{item.prod.name}</span>
            <span className="text-[12px]">
              SKU: {item.prod.skuCode} | Standard Product{" "}
              {discount ? ` | ${discount}` : ""}
            </span>
          </div>
        ) : (
          ""
        );
      case 2:
        return item.prod && item.varProd ? (
          <div
            className="grid gap-1 font-medium text-gray-500"
            onClick={() => handleView(item)}
          >
            <span className="text-[15px] link">
              {item.prod.name +
                " / " +
                item.varProd.attrVal1 +
                (item.varProd.attrVal2 && ` / ${item.varProd.attrVal2}`) +
                (item.varProd.attrVal3 && ` / ${item.varProd.attrVal3}`)}
            </span>
            <span className="text-[12px]">
              SKU: {item.varProd?.skuCode} | Variant Product{" "}
              {discount ? ` | ${discount}` : ""}
            </span>
          </div>
        ) : (
          ""
        );
      case 3:
        return item.prod ? (
          <div
            className="grid gap-1 font-medium text-gray-500"
            onClick={() => handleView(item)}
          >
            <span className="text-[15px] link">{item.prod.name}</span>
            <span className="text-[12px]">
              SKU: {item.prod.skuCode} | Composit Product{" "}
              {discount ? ` | ${discount}` : ""}
            </span>
          </div>
        ) : (
          ""
        );
      default:
        return <></>;
    }
  };

  return renderContent();
};

export default TableProdWidget;
